import { LOCATION_CHANGE } from 'connected-react-router';
import { matchPath } from 'react-router';
import {
  getUserDetails,
  getMeterRemaining,
  getMeter,
  setMeterRemaining,
} from '@surfline/web-common';
import {
  CamAndForecastsRoute,
  GeonameMapRoute,
  MapPageRoute,
  SpotPageRoute,
  PremiumAnalysisRoute,
  SubregionForecastPageRoute,
  SubregionForecastRoute,
  ChartsPageRoute,
  ChartsPageContainerRoute,
  RateLimitTestPage,
} from '../routesConfig';
import { PERFORMED_SURF_CHECK_ACTION } from '../actions/metering';
import { performMeteringSurfCheck } from '../common/api/metering';

// Array of action types that can trigger a surf check refresh
const WHITELISTED_SURF_CHECK_ACTIONS = [PERFORMED_SURF_CHECK_ACTION];

const WHITELISTED_LOCATION_CHANGES = [
  CamAndForecastsRoute,
  GeonameMapRoute,
  MapPageRoute,
  SpotPageRoute,
  PremiumAnalysisRoute,
  SubregionForecastPageRoute,
  SubregionForecastRoute,
  ChartsPageRoute,
  ChartsPageContainerRoute,
  RateLimitTestPage,
];

// TODO: Move this middleware to common and allow extension by passing in whitelisted routes.
export const surfCheckMeteringMiddleware = ({ getState, dispatch }) => {
  return (next) => (action) => {
    const state = getState();

    // If the user is not a metered user or has exceeded their surf
    // check limit for the week we can just eagerly return here since
    // we don't need to perform the PATCH call
    const meter = getMeter(state);
    const isMeteredUser = !!meter;
    const treatmentVariant = meter?.treatmentVariant;
    const isAnonmyous = !getUserDetails(state);
    const hasRemainingSurfChecks = getMeterRemaining(state) !== -1;
    // Page views are specific for Anonymous Sessions
    const hasRemainingPageViews = getMeterRemaining(state) >= 1;

    if (
      !isMeteredUser ||
      !hasRemainingSurfChecks ||
      (treatmentVariant && treatmentVariant.match(/^(off|control)$/)) ||
      (isAnonmyous && !hasRemainingPageViews)
    ) {
      return next(action);
    }

    if (WHITELISTED_SURF_CHECK_ACTIONS.indexOf(action.type) !== -1 && !isAnonmyous) {
      performMeteringSurfCheck();
      return next(action);
    }

    // Is firstRendering is a value specific to `connected-react-router` which
    // denotes the first render on the client (initial page load)
    const isFirstRender = action.payload?.isFirstRendering;

    // On the first render (server-side render being hydrated on client)
    // we don't need to worry about calling the `PATCH` surf check endpoint
    // since it is being called on the server when the page request
    // is made
    if (action.type === LOCATION_CHANGE && !isFirstRender) {
      const pathname = action.payload?.location?.pathname;
      // Iterate each whitelisted route to see if the current route
      // change matches a whitelisted route. `.some()` will return
      // as soon as it find a match so we don't perform extra work
      const matchesWhitelistedRoute = WHITELISTED_LOCATION_CHANGES.some((route) =>
        matchPath(pathname, route.routeProps),
      );
      if (matchesWhitelistedRoute) {
        if (isAnonmyous && hasRemainingPageViews) {
          // If it's an anonymous session and has active page view (meterRemaining 1)
          // Then decrement the meterRemaining on route change

          let { meterRemaining } = meter;
          meterRemaining -= 1;
          dispatch(setMeterRemaining(meterRemaining));
          return next(action);
        }
        performMeteringSurfCheck();
        return next(action);
      }
    }

    return next(action);
  };
};
